import { capriccio } from '../js/target/scala-3.7.2/capriccio-opt/main.js';
capriccio.launch("capriccio");